module.exports = __webpack_public_path__ + "prod/1.42.2/img/pain-3.626fa183.svg";